<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text"
          >{{ labelBtn }} Serviço</v-card-title
        >
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-form ref="formServices">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :value="itensForm.descricao"
                  @input="
                    ($event) => (itensForm.descricao = $event.toUpperCase())
                  "
                  label="Serviço"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="itensForm.cod_tributacao_municipio"
                  
                  label="Cód. Tributação Municipal"
                  :rules="[rules.required, rules.specialChar]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col class="d-flex" cols="12" sm="12">
                    <v-autocomplete
                      :items="listaContabilizacao"
                      v-model="itensForm.cod_contabilizacao_padrao"
                      
                      label="Cód. Contabilização Padrão"
                      dense
                      :rules="[rules.required]"
                      required
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12">
                    <v-autocomplete
                      :items="listaRendimetos"
                      v-model="itensForm.cod_nat_rend_pj"
                      label="Código nat. ret. PJ"
                      dense
                      :rules="[rules.required]"
                      required
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="itensForm.codigo_irrf"
                      label="Código IRRF"
                      :rules="[rules.specialChar]"
                      type="number"
                      :min="0"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text mr-5"
          color="error"
          @click="closeModal()"
          >FECHAR</v-btn
        >
        <v-btn
          class="white--text mr-5 btn-form"
          :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
          @click="labelBtn == 'Cadastrar' ? createService() : updateService()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import cidades from "@/services/http/endereco/cidades";
import rendimentos from "@/services/http/naturezaRendimentos";
import servicosPrestados from "@/services/http/rpa/ServicosPrestados";
import contabilizacaoPadrao from "../../../../services/http/contabilizacaoPadrao";
export default {
  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {},
  },
  data: () => ({
    selectedState: "",

    listaRendimetos: [],
    listaContabilizacao: [],
    itensForm: {
      cod_nat_rend_pj: "",
      cod_contabilizacao_padrao: "",
      cod_tributacao_municipio: "",
      descricao: "",
      codigo_irrf: "",
    },
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
      specialChar: (value) =>
        !/[^a-z\d]+/i.test(value) || "O campo não permite caracteres especiais",
    },
  }),
  created() {
    this.fetchRendimentos();

    this.fetchContabilizacaoPadrao();
  },
  methods: {
    closeModal() {
      this.$emit("update:dialog", false);
    },
    async createService() {
      if (this.$refs.formServices.validate()) {
        try {
          await servicosPrestados().store(this.itensForm);
          toast("success", "Cadastrado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal();
          await this.$parent.fetchServices();
        }
      }
    },
    async fetchRendimentos() {
      try {
        const data = await rendimentos().show({ per_page: -1 });

        this.listaRendimetos = data.data.map((item) => ({
          text: `${item.cod_nat_rend} - ${item.desc_nat_rend}`,
          value: item.cod_nat_rend,
        }));
      } catch (e) {
        console.log(e);
      }
    },

    async fetchContabilizacaoPadrao() {
      try {
        const { data } = await contabilizacaoPadrao().show({ per_page: -1 });
        this.listaContabilizacao = data.data.map((item) => ({
          text: `${item.cod_contab_padrao} - ${item.descricao}`,
          value: item.cod_contab_padrao,
        }));
      } catch (e) {
        console.log(e);
      }
    },
    async updateService() {
      if (this.$refs.formServices.validate()) {
        try {
          await servicosPrestados(this.selectedItem.id).update(this.itensForm);

          toast("success", "Alterado com sucesso");
        } catch (e) {
          toast("error", e.message);
        } finally {
          this.closeModal();
          this.formServices();
          this.$parent.fetchServices();
        }
      }
    },
    async fetchCities(uf) {
      let city = await cidades().show({ uf: uf, per_page: -1 });
      city = city.data.data;
      this.cidade_id = city.map((index) => {
        return {
          value: index.id_cidade,
          text: index.cidade,
        };
      });
    },
    async fetchOneCity(id) {
      let { data } = await cidades(id).show();
      return data;
    },
  },
  watch: {
    selectedState(uf) {
      this.fetchCities(uf);
    },
    async selectedItem(item) {
      if (item != null) {
        let address = await this.fetchOneCity(item.cidade_id);
        this.itensForm.descricao = item.tooltip || item.descricao;
        this.selectedState = address.uf;
        this.itensForm.cidade_id = address.id_cidade;
        this.itensForm.cod_contabilizacao_padrao =
          item.cod_contabilizacao_padrao;
        this.itensForm.cod_tributacao_municipio = item.cod_tributacao_municipio;
        this.itensForm.cod_nat_rend_pj = item.cod_nat_rend_pj;
        this.itensForm.codigo_irrf = item.codigo_irrf;
      }
    },
  },
};
</script>
